import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'react-feather';
import Backdrop from '../../Backdrop';
import classNames from 'classnames';
var fadeUp = {
    hidden: {
        y: '100%',
        opacity: 0,
    },
    visible: {
        y: '0',
        opacity: 1,
        transition: {
            duration: 0.25,
        },
    },
    exit: {
        y: '100%',
        opacity: 0,
    },
};
var classes = {
    base: 'h-full w-full transform overflow-auto sm:rounded-2xl sm:h-auto sm:max-h-[90%] sm:w-11/12 md:w-4/5 lg:w-4/6 xl:w-1/2 2xl:w-2/5',
    light: 'bg-white',
    dark: 'bg-brand-01 dark',
};
var ModalBasic = function (_a) {
    var handleClose = _a.handleClose, children = _a.children, _b = _a.type, type = _b === void 0 ? 'basic' : _b, open = _a.open, _c = _a.dark, dark = _c === void 0 ? false : _c, className = _a.className, subWrapperClassName = _a.subWrapperClassName, contentClassName = _a.contentClassName, _d = _a.noSpace, noSpace = _d === void 0 ? false : _d, iconClassName = _a.iconClassName;
    return (<AnimatePresence initial={false} exitBeforeEnter={true} onExitComplete={function () { return null; }}>
      {open && (<Backdrop onClick={handleClose} center>
          <motion.div onClick={function (e) { return e.stopPropagation(); }} className={classNames(className, classes.base, dark ? classes.dark : classes.light)} variants={fadeUp} initial="hidden" animate="visible" exit="exit">
            <div className={classNames(subWrapperClassName, 'h-full ', !noSpace && 'p-4 sm:p-6 md:p-8 lg:p-10')}>
              <X size={24} className={classNames('absolute top-0 right-0 m-4 cursor-pointer ', dark && 'text-white', iconClassName)} onClick={handleClose}/>
              <div className={classNames(contentClassName, !noSpace && 'mt-10')}>{children}</div>
            </div>
          </motion.div>
        </Backdrop>)}
    </AnimatePresence>);
};
export default ModalBasic;
